import { useState } from 'react'
import css from './ImagePlaceholder.module.scss'

export default function ImagePlaceholder({
	iconName,
	size,
	src,
	image = src, // I did this to prevent headaches :)
	action,
	alt,
	width = size,
	height = size,
	style,
	className,
	onError,
	placeholderWidth,
}) {
	const [imageIsValid, setImageIsValid] = useState(image)
	// const [sorc, setSrc] = useState(image)

	function handleOnError(e) {
		setImageIsValid(false)
		e.target.onerror = null
	}

	return (
		<>
			{/* <p>{imageIsValid ? "y" : "n"}</p> */}
			{imageIsValid ? (
				<img
					{...(action && { onClick: action })}
					// onClick={action ? action : undefined}
					className={css['image'] + ' ' + className}
					src={image}
					// alt={alt}
					height={height}
					width={width}
					style={{ cursor: action && 'pointer', ...style }}
					onError={e => handleOnError(e)}
					alt={alt}
				/>
			) : (
				<div
					{...(action && { onClick: action })}
					onClick={action ? action : undefined}
					className={css['fallback'] + ' ' + className}
					style={{
						width: placeholderWidth ? placeholderWidth : width,
						height: height,
						fontSize: placeholderWidth ? placeholderWidth : width,
						cursor: action && 'pointer',
						...style,
					}}>
					<i className={iconName} />
				</div>
			)}
		</>
	)
}
